// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1uCgw","buttons":"RemoveExpirationActionButtons_buttons__233Ng"};